import { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";
import "./BotonMusica.css";

export default function BotonMusica({ autoPlay }) {
  const [reproduciendo, setReproduciendo] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (autoPlay) {
      const audio = audioRef.current;
      audio.play().then(() => setReproduciendo(true)).catch(() => {});
    }
  }, [autoPlay]);

  const toggleAudio = () => {
    const audio = audioRef.current;
    if (audio.paused) {
      audio.play();
      setReproduciendo(true);
    } else {
      audio.pause();
      setReproduciendo(false);
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/gratitude.mp3" loop />
      <button
        className={`boton-musica ${reproduciendo ? "pulsando" : ""}`}
        onClick={toggleAudio}
      >
        {reproduciendo ? <FaPause /> : <FaPlay />}
      </button>
    </>
  );
}
